import React from 'react'
import Logo from '../../images/safeentry-logo.svg'

const Image = (props) => <img alt="SafeEntry Logo" src={Logo} {...props} />

export default Image
